import request from "@/utils/request"
const host = "/api/we-tunnel"

// 朋友圈评论列表
export function getList(data) {
  return request({
    url: host + `/wx/moments/listPg/comment`,
    method: "post",
    data
  })
}
// 获取评论详情
export function getCommentDetail(data) {
  return request({
    url: host + "/wx/sns/getOneSnsDetailInfo",
    method: "post",
    data
  })
}
// 朋友圈点赞、评论
export const apiSnsCommentOrLike = data => {
  return request({
    url: host + "/wx/sns/publishSnsCommentOrLike",
    method: "post",
    data
  })
}
// 取消点赞
export const apiSnsOperation = data => {
  return request({
    url: host + "/wx/sns/snsOperation",
    method: "post",
    data
  })
}
// 删除朋友圈/评论
export const apiDelFriendCircle = data => {
  return request({
    url: host + "/wx/moments/delete",
    method: "post",
    data
  })
}

// 朋友圈评论通知记录
export const apiCommentNotify = data => {
  return request({
    url: host + "/wx/moments/commentNotify",
    method: "post",
    data
  })
}

// 朋友圈评论通知记录已读
export const apiCommentNotifyRead = data => {
  return request({
    url: host + "/wx/moments/commentNotifyRead",
    method: "post",
    data
  })
}

// 上传图片到 oss
export const apiUploadOss = data => {
  return request({
    url: host + "/aliyun/uploadByUrl",
    method: "post",
    data
  })
}
